// extracted by mini-css-extract-plugin
module.exports = {"dashboardListContainer":"RequestList_dashboardListContainer__dskIZ"};